import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { TimeMethodInputProps } from './interface'

const options = [
  {
    label: '定时拍',
    value: false
  },
  {
    label: '延时拍',
    value: true
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: TimeMethodInputProps) => {
  const handleSelectChange = (allowDelay: boolean) => {
    onChange?.({ allowDelay, delayTotalCount: allowDelay ? 5 : 0 })
  }

  const handleInputCountChange = (delayTotalCount: string | number | null) => {
    onChange?.({
      ...value,
      delayTotalCount: isNil(delayTotalCount) ? 0 : Number(delayTotalCount)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={options}
        value={value.allowDelay}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled || !value.allowDelay}
        min={0}
        precision={0}
        style={{ width: '100%' }}
        value={value.delayTotalCount}
        onChange={handleInputCountChange}
      />
      <Space.Addon>次</Space.Addon>
    </Space.Compact>
  )
}

export const TimeMethodInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
